// PVA-MACHINE-PLAN-01 · pure search/filter/sort/roll-up for Plan vs Actual rows.
export const natKey = (s) => String(s || "").split(/(\d+)/).map(p => (/^\d+$/.test(p) ? p.padStart(8, "0") : p.toLowerCase())).join("");
export const productOf = (r) => r.plan_product_code || r.product_code || r.item_code || "";

const sortRows = (a, b) => natKey(a.machine_code).localeCompare(natKey(b.machine_code))
  || (a.queue_position || 999) - (b.queue_position || 999)
  || String(a.planned_start).localeCompare(String(b.planned_start))
  || String(a.plan_no).localeCompare(String(b.plan_no));

export function filterPvaRows(rows, f) {
  const q = f.search.trim().toLowerCase();
  return rows.filter(r => {
    if (q && ![r.source_wo_no, r.plan_no, r.order_no, productOf(r), r.customer, r.machine_code]
      .some(v => String(v || "").toLowerCase().includes(q))) return false;
    if (f.from && (r.planned_finish_baseline || r.planned_start || "") < f.from) return false;
    if (f.to && (r.planned_start || "") > f.to) return false;
    if (f.machine && r.machine_id !== f.machine) return false;
    if (f.status && r.execution_status !== f.status) return false;
    return true;
  }).sort(sortRows);
}

export function pvaTotals(rows) {
  const t = rows.reduce((a, r) => ({
    pln: a.pln + (+r.planned_qty || 0), prd: a.prd + (+r.produced_qty || 0),
    bal: a.bal + (+r.plan_balance_qty || 0), exc: a.exc + (+r.excess_qty || 0),
  }), { pln: 0, prd: 0, bal: 0, exc: 0 });
  return { ...t, machines: new Set(rows.map(r => r.machine_id || r.machine_code)).size, plans: rows.length };
}
